import { Injectable } from '@angular/core';
import { RuntimeConfigService } from '@app/service/runtime-config.service';
import { defer, Observable, shareReplay } from 'rxjs';

declare global {
  interface Window {
    __googleMapsCallback(): void;
  }
}

@Injectable({ providedIn: 'root' })
export class GoogleMapsService {
  private get key(): string {
    return this.runtimeConfigService.getConfig?.googleMapKey;
  }
  private scriptAdded = false;

  constructor(private readonly runtimeConfigService: RuntimeConfigService) {}
  private readonly googleMaps$ = defer(() => {
    if (!this.scriptAdded) {
      const script = document.createElement('script');
      script.async = true;
      script.setAttribute('loading', 'async');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${this.key}&libraries=places&loading=async&callback=__googleMapsCallback`;
      document.head.appendChild(script);
      this.scriptAdded = true;

      return new Observable<void>((observer) => {
        // eslint-disable-next-line no-underscore-dangle
        window.__googleMapsCallback = () => {
          observer.next();
          observer.complete();
        };

        if (window.google?.maps) {
          observer.next();
          observer.complete();
        }

        const onError = (error: ErrorEvent) => {
          observer.error(error);
        };

        script.addEventListener('error', onError);
        return () => {
          script.removeEventListener('error', onError);
        };
      });
    }

    return new Observable<void>((observer) => {
      // eslint-disable-next-line no-underscore-dangle
      window.__googleMapsCallback = () => {
        observer.next();
        observer.complete();
      };

      if (window.google?.maps) {
        observer.next();
        observer.complete();
      }
    });
  }).pipe(shareReplay({ bufferSize: 1, refCount: true }));

  getGoogleMaps() {
    return this.googleMaps$;
  }
}
